/* eslint-ignore */
// @ts-nocheck
import { Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import { IoMdArrowBack, IoMdPersonAdd } from 'react-icons/io';
import { MdLockOutline } from 'react-icons/md';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ReactComponent as IconFormUser } from '~/assets/icons/form-user.svg';
import { ReactComponent as IconPhoneLink } from '~/assets/icons/phonelink.svg';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import TextField from '~/components/layout/form/textField';
import api from '~/services/api';
import {
  registerContactName,
  toggleStep,
} from '~/store/actions/singup-actions';
import { FormBox, FormHeader } from './styles';

const regex =
  /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])(?=.{8,})/;

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showPassword: false,
      enviado: false,
    };
  }

  componentWillMount() {
    // this.sendSmsCode();
  }

  SignUpSchema = () =>
    Yup.object().shape({
      email: Yup.string()
        .required('Insira um e-mail válido')
        .email('Complete o campo com um e-mail válido'),
      token: Yup.number('O token é composto somente por números').required(
        'Insira um código'
      ),
      password: Yup.string()
        .required('Insira uma senha')
        .matches(
          regex,
          'Use oito ou mais caracteres com uma combinação de letras, números e símbolos'
        ),
      passwordConfirmation: Yup.string()
        .required('Insira a confirmação de sua senha')
        .oneOf([Yup.ref('password'), null], 'As senhas não combinam'),
    });

  sendSmsCode = () => {
    const { contactName, contactId, url } = this.props;
    if ((contactName, contactId)) {
      const header = {
        'Content-Type': 'application/json',
      };
      const parameters = {
        method: 'POST',
        headers: header,
      };
      const body = {
        tokenType: 'ADD_CONTACT',
        contactId,
      };
      api
        .post(`industrial/customer/v1/tokens`, body, parameters)
        .then((res) => {
          toast.success(
            `Um código de SMS foi enviado para o telefone: ${contactName}`
          );
        })
        .catch((err) => {
          const { message } = err.response.data;
          if (message) {
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    } else {
      this.props.dispatch(toggleStep(1));
    }
  };

  // Segunda requisição
  requestRegisterEmail = async (values) => {
    this.setState({ loading: true });
    const { siteId, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      contact: values.email,
      contactType: 'EMAIL',
      token: values.token,
      siteId,
    };

    if (!siteId) {
      toast.error('Não conseguimos identificar seu endereço!');
    }

    api
      .post(`industrial/customer/v1/users/${userId}/contacts`, body, parameters)
      .then((res) => {
        if (res.status === 201) {
          const contactId = res.headers.location.split('/').pop();
          if (contactId) {
            this.requestRegisterPassword(values, contactId);
          } else {
            this.setState({ loading: false });
            toast.error('Não foi possível cadastrar este e-mail!');
          }
        } else {
          this.setState({ loading: false });
          toast.error('Não foi possível cadastrar este e-mail!');
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  // Terceira requisição
  requestRegisterPassword = (values, contactId) => {
    const { url, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      contactId,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/passwords`,
        body,
        parameters
      )
      .then((res) => {
        this.props.dispatch(registerContactName(values.email, contactId));
        this.setState({ loading: false });
        this.sendValidationToken(contactId, userId, url);
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  sendValidationToken = (contactId, userId, url) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      tokenType: 'REGISTER',
      url: process.env.REACT_APP_REGISTER_URL_CONFIRMATION,
      contactId,
    };
    api
      .post(`industrial/customer/v1/users/${userId}/tokens`, body, parameters)
      .then((res) => {
        this.props.dispatch(toggleStep(5));
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          toast.error(message);
        } else {
          toast.error('Ocorreu um erro interno na aplicação');
          toast.error(
            'Certifique-se de estar conectado a internet ou tente novamente mais tarde!'
          );
        }
      });
  };

  handleCode = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, '');
    event.target.value = numbers;
    handleChange(event);
  };

  handlePassVisibility() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  render() {
    return (
      <FormBox>
        <Formik
          initialValues={{
            email: '',
            token: '',
            password: '',
            confirmPassword: '',
          }}
          onSubmit={(values) => {
            this.requestRegisterEmail(values);
          }}
          validationSchema={this.SignUpSchema}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <>
              <FormHeader>
                <h2>Estamos quase lá!.</h2>
              </FormHeader>
              <Form>
                <span
                  style={{
                    fontSize: 16,
                    color: '#5e5e5e',
                    display: 'grid',
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                >
                  Insira o token enviado por SMS para o celular
                  <br />
                  {this.props.contactName}
                </span>
                <BootstrapForm.Group controlId="token">
                  <TextField
                    id="token"
                    type="text"
                    title="Código de ativação"
                    placeholder="Código de ativação"
                    label="Código de ativação"
                    ariaLabel="Código de ativação"
                    ariaRequired
                    errorCondition={errors.token && touched.token}
                    errorMessage={errors.token}
                    onBlur={handleBlur}
                    LeadingIcon={() => <IconPhoneLink />}
                    value={values.token}
                    onChange={(e) => {
                      this.handleCode(e, handleChange);
                    }}
                  />
                </BootstrapForm.Group>
                <span style={{ fontSize: 16, color: '#074f8c' }}>
                  Não recebeu o codigo?
{' '}
                  <a
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => this.sendSmsCode()}
                    name="reenviarCodigo"
                    id="reenviarCodigo"
                  >
                    Clique aqui para reenviar
                  </a>
                </span>
                <div
                  className="d-flex justify-content-center w-100 mb-2"
                  style={{ marginTop: 10 }}
                />
                <BootstrapForm.Group controlId="email">
                  <TextField
                    id="email"
                    type="text"
                    title="E-mail"
                    placeholder="E-mail"
                    label="E-mail"
                    ariaLabel="Seu e-mail"
                    ariaRequired
                    errorCondition={errors.email && touched.email}
                    errorMessage={errors.email}
                    onBlur={handleBlur}
                    value={values.email}
                    onChange={handleChange}
                    LeadingIcon={() => <IconFormUser />}
                  />
                </BootstrapForm.Group>
                <BootstrapForm.Group controlId="password">
                  <TextField
                    id="password"
                    name="password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    title="Senha"
                    placeholder="Crie uma nova senha *"
                    label="Crie uma nova senha *"
                    ariaLabel="Crie uma nova senha *"
                    ariaRequired
                    showChangeTextPassword="true"
                    errorCondition={errors.password && touched.password}
                    errorMessage={errors.password}
                    onBlur={handleBlur}
                    value={values.password}
                    onChange={handleChange}
                    LeadingIcon={() => <MdLockOutline size={25} />}
                  />
                </BootstrapForm.Group>
                <span
                  style={{
                    fontSize: 14,
                    color: '#b4b4b4',
                    display: 'grid',
                    marginTop: 10,
                  }}
                >
                  Use oito ou mais caracteres com uma combinação de letras,
                  números e símbolos
                </span>
                <br />
                <BootstrapForm.Group controlId="passwordConfirmation">
                  <TextField
                    id="passwordConfirmation"
                    type="password"
                    title="Confirmação de Senha"
                    placeholder="Repita sua nova senha"
                    label="Repita sua nova senha"
                    ariaLabel="Confirmação de Senha"
                    ariaRequired
                    showChangeTextPassword="true"
                    errorCondition={
                      errors.passwordConfirmation &&
                      touched.passwordConfirmation
                    }
                    errorMessage={errors.passwordConfirmation}
                    onBlur={handleBlur}
                    value={values.passwordConfirmation}
                    onChange={handleChange}
                    LeadingIcon={() => <MdLockOutline size={25} />}
                  />
                </BootstrapForm.Group>
                <div style={{ marginTop: 50 }}>
                  <ContainedButton
                    className="mb-2"
                    block
                    continue
                    type="submit"
                    icon="arrow-right"
                    text="Continuar"
                    color="#288efd"
                    loading={this.state.loading}
                    name="Continuar"
                    id="Continuar"
                    width="100%"
                    TrailingIcon={() => <IoMdPersonAdd size={20} />}
                  >
                    Continuar
                  </ContainedButton>
                  <OutlinedButton
                    onClick={() => this.props.dispatch(toggleStep(3))}
                    className="mb-2"
                    block
                    outline
                    text="Voltar"
                    color="#76d2e1"
                    name="Voltar"
                    id="Voltar"
                    width="100%"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                  >
                    Voltar
                  </OutlinedButton>
                </div>
              </Form>
            </>
          )}
        />
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.signUpReducer.token,
  contactName: state.signUpReducer.contactName,
  contactId: state.signUpReducer.contactId,
  url: state.signUpReducer.url,
  siteId: state.signUpReducer.siteId,
  userId: state.signUpReducer.userId,
});

export default connect(mapStateToProps)(SignupComponent);
